import { LiliRadioInput, LiliRadioInputVariant } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '@Hooks/index';
import type { CardShipmentAddressType } from '@Store/slices/customer/customer.types';

interface CardShipmentSelectionProps {
  options: { value: CardShipmentAddressType; label: string }[];
  fieldName: string;
}

export const CardShipmentSelection = ({ options, fieldName }: CardShipmentSelectionProps) => {
  return (
    <div className='flex flex-col gap-[16px]'>
      <ControllerWrapper name={fieldName}>
        {({ onChange, value }) => (
          <>
            {options.map((option) => (
              <LiliRadioInput
                key={option.value}
                label={option.label}
                id={`card-shipment-${option.value}`}
                value={option.value}
                onChange={() => onChange(option.value)}
                checked={value === option.value}
                name={fieldName}
                variant={LiliRadioInputVariant.DOT}
              />
            ))}
          </>
        )}
      </ControllerWrapper>
    </div>
  );
};
